import React, { useEffect } from "react";
import { Container, Row } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";

import Widgets from "../../Components/Dashboard/Widgets";
import Clients from "../../Components/Dashboard/Clients";
import Loader from "../../Components/Common/Loader";
import Error from "../../Components/Common/Error";

import {
  getTotalCertifications,
  getTotalClientAdmin,
  getTotalClientAuditors,
  getTotalClients,
  getTotalClientUsers,
  getTotalUsers
} from "../../slices/Dashboard/thunk";
import { getClients } from "../../slices/ManageClient/thunk";

const Dashboard = () => {
  const dispatch = useDispatch();

  // Dashboard state
  const {
    isLoading: dashboardLoading,
    isError: dashboardError,
    totalClients,
    totalUsers,
    totalClientAdmin,
    totalClientUsers,
    totalClientAuditors,
    totalCertifications
  } = useSelector((state) => state.Dashboard);

  // Clients state
  const {
    isLoading: clientsLoading,
    isError: clientsError,
    clientsList: clients
  } = useSelector((state) => state.GetAllClients);

  useEffect(() => {
    // Dispatch dashboard data actions
    const fetchDashboardData = () => {
      dispatch(getTotalClients());
      dispatch(getTotalUsers("CLIENT_USER"));
      dispatch(getTotalClientAdmin("CLIENT_ADMIN"));
      dispatch(getTotalClientUsers("CLIENT_USER"));
      dispatch(getTotalClientAuditors("AUDITOR"));
      dispatch(getTotalCertifications());
    };

    fetchDashboardData();
  }, [dispatch]);

  useEffect(() => {
    // Fetch clients data
    dispatch(getClients());
  }, [dispatch]);

  // Combine loading and error states
  const isLoading = dashboardLoading || clientsLoading;
  const isError = dashboardError || clientsError;

  if (isLoading) return <Loader />;
  if (isError) return <Error />;

  return (
    <div className="page-content">
      <Container fluid>
        <Row>
          <Widgets
            totalClients={totalClients}
            totalUsers={totalUsers}
            totalClientAdmin={totalClientAdmin}
            totalClientUsers={totalClientUsers}
            totalClientAuditors={totalClientAuditors}
            totalCertifications={totalCertifications}
          />
          <Clients clients={clients} />
        </Row>
      </Container>
    </div>
  );
};

export default Dashboard;